/**
 * @generated SignedSource<<3eda00d78e6036a5831918d4f0ad729c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNoteEditingMode = "DEFAULT" | "READ_ONLY";
export type WidgetNoteFontSize = "LARGE" | "MEDIUM" | "SMALL";
export type WidgetNoteFontStyle = "BOLD" | "CURSIVE" | "DEFAULT";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetNoteInput = {
  id: string;
  pages: ReadonlyArray<WidgetNotePreviewPageInput>;
  size: WidgetOverviewSize;
  storecastId?: string | null;
  title: string;
};
export type WidgetNotePreviewPageInput = {
  backgroundColor?: string | null;
  currentValue: string;
  fontSize: WidgetNoteFontSize;
  fontStyle: WidgetNoteFontStyle;
  id: string;
  imageScale?: number | null;
  imageTranslateX?: number | null;
  imageTranslateY?: number | null;
  includedInSlideshow: boolean;
  remoteImageURL?: string | null;
};
export type WACategoryNotePreviewsQuery$variables = {
  input1: PreviewWidgetNoteInput;
  input2: PreviewWidgetNoteInput;
  input3: PreviewWidgetNoteInput;
  storecastId: string;
};
export type WACategoryNotePreviewsQuery$data = {
  readonly dashboard: {
    readonly previewWidgetNote1: {
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
    };
    readonly previewWidgetNote2: {
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
    };
    readonly previewWidgetNote3: {
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
    };
  };
};
export type WACategoryNotePreviewsQuery$rawResponse = {
  readonly dashboard: {
    readonly id: string;
    readonly previewWidgetNote1: {
      readonly id: string;
      readonly note: {
        readonly editingMode: WidgetNoteEditingMode;
        readonly id: string;
        readonly isOrgNote: boolean;
        readonly noteSize: WidgetNoteSize;
        readonly pages: ReadonlyArray<{
          readonly backgroundColor: string | null;
          readonly containImage: boolean | null;
          readonly currentValue: string;
          readonly fontColor: string | null;
          readonly fontSize: WidgetNoteFontSize;
          readonly fontStyle: WidgetNoteFontStyle;
          readonly id: string;
          readonly image: {
            readonly id: string;
            readonly largeImage: {
              readonly height: number;
              readonly id: string;
              readonly url: string;
              readonly width: number;
            } | null;
          } | null;
          readonly imageScale: number | null;
          readonly imageTranslateX: number | null;
          readonly imageTranslateY: number | null;
          readonly includedInSlideshow: boolean;
          readonly remoteImageURL: string | null;
          readonly version: string;
        }>;
        readonly title: string;
      };
      readonly title: string;
    };
    readonly previewWidgetNote2: {
      readonly id: string;
      readonly note: {
        readonly editingMode: WidgetNoteEditingMode;
        readonly id: string;
        readonly isOrgNote: boolean;
        readonly noteSize: WidgetNoteSize;
        readonly pages: ReadonlyArray<{
          readonly backgroundColor: string | null;
          readonly containImage: boolean | null;
          readonly currentValue: string;
          readonly fontColor: string | null;
          readonly fontSize: WidgetNoteFontSize;
          readonly fontStyle: WidgetNoteFontStyle;
          readonly id: string;
          readonly image: {
            readonly id: string;
            readonly largeImage: {
              readonly height: number;
              readonly id: string;
              readonly url: string;
              readonly width: number;
            } | null;
          } | null;
          readonly imageScale: number | null;
          readonly imageTranslateX: number | null;
          readonly imageTranslateY: number | null;
          readonly includedInSlideshow: boolean;
          readonly remoteImageURL: string | null;
          readonly version: string;
        }>;
        readonly title: string;
      };
      readonly title: string;
    };
    readonly previewWidgetNote3: {
      readonly id: string;
      readonly note: {
        readonly editingMode: WidgetNoteEditingMode;
        readonly id: string;
        readonly isOrgNote: boolean;
        readonly noteSize: WidgetNoteSize;
        readonly pages: ReadonlyArray<{
          readonly backgroundColor: string | null;
          readonly containImage: boolean | null;
          readonly currentValue: string;
          readonly fontColor: string | null;
          readonly fontSize: WidgetNoteFontSize;
          readonly fontStyle: WidgetNoteFontStyle;
          readonly id: string;
          readonly image: {
            readonly id: string;
            readonly largeImage: {
              readonly height: number;
              readonly id: string;
              readonly url: string;
              readonly width: number;
            } | null;
          } | null;
          readonly imageScale: number | null;
          readonly imageTranslateX: number | null;
          readonly imageTranslateY: number | null;
          readonly includedInSlideshow: boolean;
          readonly remoteImageURL: string | null;
          readonly version: string;
        }>;
        readonly title: string;
      };
      readonly title: string;
    };
  } | null;
};
export type WACategoryNotePreviewsQuery = {
  rawResponse: WACategoryNotePreviewsQuery$rawResponse;
  response: WACategoryNotePreviewsQuery$data;
  variables: WACategoryNotePreviewsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input1"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input2"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input3"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input1"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "WidgetNote_widgetNote"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input2"
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input3"
  }
],
v11 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Note",
    "kind": "LinkedField",
    "name": "note",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "editingMode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isOrgNote",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WidgetNotePage",
        "kind": "LinkedField",
        "name": "pages",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": "largeImage",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "minHeight",
                    "value": 1080
                  },
                  {
                    "kind": "Literal",
                    "name": "minWidth",
                    "value": 1080
                  }
                ],
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "size",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": "size(minHeight:1080,minWidth:1080)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fontColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "includedInSlideshow",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backgroundColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fontSize",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fontStyle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageScale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageTranslateX",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageTranslateY",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remoteImageURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "containImage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noteSize",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WACategoryNotePreviewsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v4/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": "previewWidgetNote1",
              "args": (v5/*: any*/),
              "concreteType": "WidgetNote",
              "kind": "LinkedField",
              "name": "previewWidgetNote",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "previewWidgetNote2",
              "args": (v9/*: any*/),
              "concreteType": "WidgetNote",
              "kind": "LinkedField",
              "name": "previewWidgetNote",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "previewWidgetNote3",
              "args": (v10/*: any*/),
              "concreteType": "WidgetNote",
              "kind": "LinkedField",
              "name": "previewWidgetNote",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "WACategoryNotePreviewsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": "previewWidgetNote1",
            "args": (v5/*: any*/),
            "concreteType": "WidgetNote",
            "kind": "LinkedField",
            "name": "previewWidgetNote",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": "previewWidgetNote2",
            "args": (v9/*: any*/),
            "concreteType": "WidgetNote",
            "kind": "LinkedField",
            "name": "previewWidgetNote",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": "previewWidgetNote3",
            "args": (v10/*: any*/),
            "concreteType": "WidgetNote",
            "kind": "LinkedField",
            "name": "previewWidgetNote",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b340995f922d7ee67a9a71a1d9c7469f",
    "id": null,
    "metadata": {},
    "name": "WACategoryNotePreviewsQuery",
    "operationKind": "query",
    "text": "query WACategoryNotePreviewsQuery(\n  $storecastId: ID!\n  $input1: PreviewWidgetNoteInput!\n  $input2: PreviewWidgetNoteInput!\n  $input3: PreviewWidgetNoteInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetNote1: previewWidgetNote(input: $input1) {\n      id\n      title\n      ...WidgetNote_widgetNote\n    }\n    previewWidgetNote2: previewWidgetNote(input: $input2) {\n      id\n      title\n      ...WidgetNote_widgetNote\n    }\n    previewWidgetNote3: previewWidgetNote(input: $input3) {\n      id\n      title\n      ...WidgetNote_widgetNote\n    }\n    id\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment NoteWeb_note on Note {\n  id\n  title\n  isOrgNote\n  noteSize\n  editingMode\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    includedInSlideshow\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment WidgetNote_widgetNote on WidgetNote {\n  id\n  note {\n    editingMode\n    isOrgNote\n    pages {\n      id\n    }\n    ...NoteWeb_note\n    ...NoteNative_note\n    id\n  }\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  fontColor\n  image {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4e4e1fecc602d00f3f1b5e618990b9a6";

export default node;
